import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

import { type CmsButtonApiProps, CmsButtonApiPropsSchema } from './cms-button'
import {
  type ProductCategories,
  ProductCategoriesSchema,
} from './product-category'

export type ProductGradesApiProps = {
  technicalName?: Maybe<string>
  categories: ProductCategories
  title?: Maybe<string>
  subtitle?: Maybe<string>
  button?: Maybe<CmsButtonApiProps>
}

export const ProductGradesApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  title: z.nullish(z.string()),
  subtitle: z.nullish(z.string()),
  categories: ProductCategoriesSchema,
  button: z.nullish(CmsButtonApiPropsSchema),
})

/* Schemas validation */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type TestProductGrades = ExpectTrue<
  Equal<ProductGradesApiProps, z.infer<typeof ProductGradesApiPropsSchema>>
>
